import { AdSlotRenderer } from './ad-slot.renderer';
import { AdSet } from '../../entities/ad-set';
import { RendererInterface } from '../../interfaces/components/renderer/renderer.interface';
import { Injectable } from '../dependency-injection/decorators';
import { AdSetLifecycleEvent } from '../event-manager/event/ad-set-lifecycle.event';
import { Events } from '../event-manager/event/events';
import { EventManager } from '../event-manager/event-manager';

@Injectable()
export class AdSetRenderer implements RendererInterface {
  public constructor (private readonly eventManager: EventManager, private readonly adSlotRenderer: AdSlotRenderer) {
  }

  public async render (adSet?: AdSet): Promise<void> {
    if (!adSet) {
      return;
    }

    const event = await this.eventManager.dispatch(
      Events.AD_SET_PRE_RENDER,
      new AdSetLifecycleEvent(adSet),
    );

    if (event.isPropagationStopped()) {
      return;
    }

    // AdSet might be changed by the event
    for (const adSlot of event.getAdSet().getAdSlots()) {
      await this.adSlotRenderer.render(adSlot);
    }

    await this.eventManager.dispatch(Events.AD_SET_POST_RENDER, new AdSetLifecycleEvent(adSet));
  }
}
